import { Button, Grid } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { useMemo, useState } from "react";
import {
  InternalOnboardingTimeline,
  OnboardingTimeline,
  OnboardingTimelineGallery,
} from "../../../graphql/models";
import { i18nForFields } from "../../../i18n";
import { I18NTextField } from "../i18n_text_field";
import { OnboardingTimelineGalleryComponent } from "./onboarding_timeline_gallery";

export interface OnboardingTimelineRowComponentProps {
  row: InternalOnboardingTimeline;
  index: number;
  onChange: (item: OnboardingTimeline, index: number) => void;
}

export function OnboardingTimelineRowComponent(
  props: OnboardingTimelineRowComponentProps
) {
  const { row } = props;
  const [editMode, setEditMode] = useState<boolean>(
    row?.isNewRow === true ?? false
  );
  const [i18nFields, setI18nFields] = useState<
    Partial<i18nForFields<"textDate" | "description">>
  >(row?.i18n ?? {});
  const [hiddenDate, setHiddenDate] = useState<Date>(row.hiddenDate);
  const galleryDefaultValue = useMemo(() => {
    const v: OnboardingTimelineGallery = {
      title: "",
      description: "",
      photos: [],
      i18n: {},
    };
    return v;
  }, []);
  const [gallery, setGallery] = useState<OnboardingTimelineGallery>(
    row?.gallery ?? galleryDefaultValue
  );
  const triggerSetHiddenDate = (v: Date | null | undefined) => {
    if (v) setHiddenDate(v);
  };
  const triggerOnChange = () => {
    const newGallery = { ...gallery };
    newGallery.title = newGallery.i18n?.title_it ?? "";
    const newRow: OnboardingTimeline = {
      hiddenDate: hiddenDate,
      i18n: i18nFields,
      textDate: i18nFields?.textDate_it ?? "",
      description: i18nFields?.description_it ?? "",
      gallery: newGallery,
    };

    console.log(`triggering updated row`);
    console.log(newRow);
    props.onChange(newRow, props.index);
    triggerEditMode();
  };
  const triggerEditMode = () => {
    console.log(`triggering edit mode`);
    setEditMode(!editMode);
  };
  // const backgroundColor = props.index % 2 === 0 ? "#888" : "#999";
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              padding: "2px 10px",
              backgroundColor: "InfoBackground",
              color: "InfoText",
            }}
          >
            <strong>Riga {props.index + 1}</strong>
          </p>
        </div>
      </Grid>
      <Grid item md={4} lg={3}>
        <DatePicker
          value={hiddenDate}
          onChange={(e) => triggerSetHiddenDate(e)}
          label="Data esatta (solo per ordinamento)"
          variant="dialog"
          disabled={!editMode}
          style={{ width: "100%" }}
        ></DatePicker>
      </Grid>
      <Grid item md={4} lg={3}>
        <I18NTextField
          label="Testo colonna data"
          i18nFieldName="textDate"
          value={i18nFields}
          onChange={setI18nFields}
          disabled={!editMode}
          variant="outlined"
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item md={4} lg={6}>
        <I18NTextField
          label="Descrizione"
          i18nFieldName="description"
          value={i18nFields}
          onChange={setI18nFields}
          disabled={!editMode}
          variant="outlined"
          multiline
          rows={3}
          style={{ width: "100%" }}
        />
      </Grid>
      {editMode && (
        <Grid item xs={12}>
          <OnboardingTimelineGalleryComponent
            gallery={gallery}
            onChange={setGallery}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        {editMode && (
          <Button onClick={triggerOnChange} variant="outlined" color="primary">
            Conferma modifiche riga
          </Button>
        )}
        {!editMode && (
          <Button onClick={triggerEditMode} variant="outlined">
            Modifica riga
          </Button>
        )}
      </Grid>
    </Grid>
  );
}
